import { render, staticRenderFns } from "./ProductListSwipe.vue?vue&type=template&id=87b75a90&scoped=true&"
import script from "./ProductListSwipe.vue?vue&type=script&lang=js&"
export * from "./ProductListSwipe.vue?vue&type=script&lang=js&"
import style0 from "./ProductListSwipe.vue?vue&type=style&index=0&id=87b75a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b75a90",
  null
  
)

export default component.exports